
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Users Components

// import { AdvertiserComponent } from './advertiser.component';
// import { AdLoginComponent } from './ad-login/ad-login.component';
// import { AdSignupComponent } from './ad-signup/ad-signup.component';
// import { LandingComponent } from './landing/landing.component';
// import { adTermsComponent } from './terms/terms.component';
// import { CampaignListComponent } from './campaign-list/campaign-list.component';
// import { CreateCompaignComponent } from './compaign/createcompaign.component';
// import { PrivacyComponent } from './privacy/privacy.component';
// import { UserResetrpasswordComponent } from './resetpassword/resetpassword.component';
// //Common components
// import { AdlandingComponent } from './adlanding/adlanding.component';
// // import { FooterComponent } from '../../common/footer.component';
// import { InterestComponent } from './interest/interest.component';
// import { SignupComponent } from './signup/signup.component';
const routes: Routes = [
    // { 
    //   path: '',
    //   component: AdvertiserComponent,
    // },
    { 
      path: 'advertiser/adlogin',
      // component: AdLoginComponent,
      loadChildren: './ad-login/ad-login.module#AdLoginModule' 
    },
    { 
      path: 'advertiser/adlogin/emailVerify/:id',
      // component: AdLoginComponent,
      loadChildren: './ad-login/ad-login.module#AdLoginModule' 
    },
    { 
      path: 'advertiser/adsignup',
      // component: AdSignupComponent
      loadChildren: './ad-signup/ad-signup.module#AdSignupModule' 
    },
    { 
       path: 'advertiser/home',
       loadChildren: './adlanding/adlanding.module#AdlandingModule' 
    },
    { 
      path: 'advertiser/campaignlist', 
      // component: CampaignListComponent,
      loadChildren: './campaign-list/campaign-list.module#CampaignListModule' 
    },
    {
       path: 'advertiser/createcampaign',
       loadChildren: './compaign/createcompaign.module#CreateCompaignModule' 
     },
     {
       path: 'advertiser/userprofile',
       loadChildren: './user-profile/user-profile.module#ProfileModule' 
     },
     {
       path: 'advertiser/terms',
       loadChildren: './advterms/terms.module#TermsModule' 
     },
     {
        path: 'advertiser/account',
        loadChildren: './adaccount/adaccount.module#AdaccountModule' 
     },
     {
        path: 'advertiser/account/:payment', 
        loadChildren: './adaccount/adaccount.module#AdaccountModule' 
     },
     { 
        path: 'advertiser/draftcampaign', 
        loadChildren: './draftcampaign/draftcampaign.module#DraftCampaignModule'
      },
      {
        path: 'advertiser/resetpassword',
        loadChildren: './advresetpassword/resetpassword.module#ResetpasswordModule'
      },
      { 
        path: 'advertiser/viewcampaign/:id', 
        loadChildren: './viewcampaign/viewcampaign.module#ViewCampaignModule' 
      },
      { 
        path: 'advertiser/resetconfirm/:key', 
        loadChildren: './resetconfirm/resetconfirm.module#AdvResetConfirmModule'
      }
    
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class AdvertiserRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/advertiser/advertiser-routing.module.ts